module.exports = __webpack_public_path__ + "media/images/main-fff90a720d9b4bbedcab083d37fe19be.jpg";